import { render, staticRenderFns } from "./AddBudgetModal.vue?vue&type=template&id=c7135092&scoped=true"
import script from "./AddBudgetModal.vue?vue&type=script&lang=js"
export * from "./AddBudgetModal.vue?vue&type=script&lang=js"
import style0 from "./AddBudgetModal.vue?vue&type=style&index=0&id=c7135092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7135092",
  null
  
)

export default component.exports